document.addEventListener("DOMContentLoaded", function () {
    attachInputListeners();

    document.addEventListener('submit', function(event) {
        if (event.target && event.target.matches("form.contact__form")) {
            handleRecallFormSubmit(event);
        }
    });
});

function attachInputListeners() {
    const formInputs = document.querySelectorAll('.js-label');

    for (const formInput of formInputs) {
        const formInputParent = formInput.closest('.form__item');
        
        formInput.addEventListener('focusin', () => {
            formInputParent.classList.add('form__item--active');
        });
        
        formInput.addEventListener('focusout', () => {
            if(formInput.value == '') {
                formInputParent.classList.remove('form__item--active');
            } else {
                formInputParent.classList.add('form__item--active');
            }
        });

        formInput.addEventListener('input', () => {
            if(formInput.value == '') {
                formInputParent.classList.remove('form__item--active');
            } else {
                formInputParent.classList.add('form__item--active');
            }
        });
    }
}

function handleRecallFormSubmit(e) {
    e.preventDefault();

    let formData = new FormData(),
        form = Object.fromEntries(new FormData(e.target))

    Object.keys(form).forEach(function (item) {
        formData.append(item, form[item]);
    });

    formData.append("action", "submit-contact-ajax");
    if (typeof variables !== 'undefined' && variables.current_language) {
        formData.append("lang", variables.current_language);
    }
    let params = new URLSearchParams(formData);
    fetch(urls.ajax, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Cache-Control": "no-cache",
        },
        body: params,
    })
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            if (response.success) {
                e.target.parentNode.innerHTML = '<div class="contact__error"><span class="message success">' + response.data.message + '</span></div>';
            } else {
                e.target.parentNode.innerHTML = response.data.form;
                attachInputListeners();
            }
        });
}



